export interface CategoryItem {
  id: string;
  name: string;
  icon: string;
  description: string;
  articleCount: number;
}

export const categoriesData: CategoryItem[] = [
  {
    id: 'cat-getting-started',
    name: '入门指南',
    icon: 'ri-rocket-line',
    description: '从零开始了解 luluca，快速上手掌握基础操作与核心功能。',
    articleCount: 12,
  },
  {
    id: 'cat-features',
    name: '特色功能',
    icon: 'ri-star-line',
    description: '深度探索 luluca 的各项强大功能，解锁更多创作可能性。',
    articleCount: 18,
  },
  {
    id: 'cat-tutorials',
    name: '使用教程',
    icon: 'ri-book-read-line',
    description: '详细的步骤教学，手把手教你完成各种创作任务。',
    articleCount: 24,
  },
  {
    id: 'cat-cases',
    name: '案例分享',
    icon: 'ri-gallery-line',
    description: '真实用户的优秀作品展示，看看 luluca 能创造什么。',
    articleCount: 15,
  },
  {
    id: 'cat-updates',
    name: '更新动态',
    icon: 'ri-flashlight-line',
    description: 'luluca 最新功能更新、版本发布与产品动态。',
    articleCount: 8,
  },
  {
    id: 'cat-tips',
    name: '创作技巧',
    icon: 'ri-lightbulb-line',
    description: '实用的设计技巧与创意灵感，提升你的创作水平。',
    articleCount: 20,
  },
];

export interface ArticlePreview {
  id: string;
  categoryId: string;
  title: string;
  excerpt: string;
  coverImage: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
}

export const articlesData: ArticlePreview[] = [
  {
    id: 'article-1',
    categoryId: 'cat-getting-started',
    title: '5分钟快速上手 luluca：新用户必看入门指南',
    excerpt: '刚接触 luluca？这篇指南将带你从注册账号到完成第一个作品，只需5分钟就能掌握核心操作流程。',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20workspace%20with%20laptop%20displaying%20creative%20design%20software%20interface%2C%20warm%20ambient%20lighting%2C%20clean%20desk%20setup%2C%20coffee%20cup%2C%20artistic%20atmosphere%2C%20soft%20shadows&width=800&height=450&seq=article-cover-1&orientation=landscape',
    author: 'luluca 官方',
    date: '2026-08-05',
    readTime: '5 分钟',
    tags: ['入门', '新手指南', '快速上手'],
  },
  {
    id: 'article-2',
    categoryId: 'cat-getting-started',
    title: 'luluca 界面布局详解：认识每一个功能区域',
    excerpt: '全面了解 luluca 的工作台布局，从工具栏到图层面板，熟悉每个功能区域的作用与快捷操作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Clean%20modern%20UI%20interface%20design%20mockup%20on%20screen%2C%20creative%20software%20workspace%2C%20warm%20neutral%20tones%2C%20minimalist%20desk%20environment%2C%20soft%20natural%20light%2C%20professional%20setup&width=800&height=450&seq=article-cover-2&orientation=landscape',
    author: '陈小北',
    date: '2026-08-03',
    readTime: '8 分钟',
    tags: ['界面', '工作台', '基础操作'],
  },
  {
    id: 'article-3',
    categoryId: 'cat-features',
    title: 'AI 智能配色：让你的设计配色不再纠结',
    excerpt: 'luluca 的 AI 配色引擎如何工作？深入了解智能配色背后的原理，以及如何利用它快速打造专业配色方案。',
    coverImage: 'https://readdy.ai/api/search-image?query=Color%20palette%20swatches%20arranged%20artistically%20on%20warm%20minimal%20background%2C%20design%20tools%2C%20creative%20studio%20vibe%2C%20soft%20lighting%2C%20harmonious%20color%20combinations%2C%20modern%20aesthetic&width=800&height=450&seq=article-cover-3&orientation=landscape',
    author: '王设计',
    date: '2026-08-01',
    readTime: '10 分钟',
    tags: ['AI', '配色', '设计技巧'],
  },
  {
    id: 'article-4',
    categoryId: 'cat-features',
    title: '模板库深度解析：找到最适合你的设计起点',
    excerpt: 'luluca 模板库涵盖哪些类别？如何根据需求快速筛选和定制模板？一文带你玩转模板功能。',
    coverImage: 'https://readdy.ai/api/search-image?query=Collection%20of%20design%20templates%20displayed%20on%20screen%20grid%2C%20minimalist%20workspace%2C%20warm%20ambient%20light%2C%20clean%20modern%20aesthetic%2C%20creative%20studio%20atmosphere%2C%20organized%20layout&width=800&height=450&seq=article-cover-4&orientation=landscape',
    author: 'luluca 官方',
    date: '2026-07-28',
    readTime: '12 分钟',
    tags: ['模板', '设计', '效率'],
  },
  {
    id: 'article-5',
    categoryId: 'cat-tutorials',
    title: '制作一张吸睛的小红书封面：完整教程',
    excerpt: '跟着步骤一步步操作，用 luluca 在10分钟内制作出高点击率的小红书封面图。',
    coverImage: 'https://readdy.ai/api/search-image?query=Social%20media%20content%20creation%20workspace%20with%20smartphone%20displaying%20colorful%20app%20interface%2C%20warm%20lighting%2C%20creative%20desk%20setup%2C%20modern%20minimal%20style%2C%20soft%20shadows&width=800&height=450&seq=article-cover-5&orientation=landscape',
    author: '林创意',
    date: '2026-07-25',
    readTime: '10 分钟',
    tags: ['小红书', '封面', '教程'],
  },
  {
    id: 'article-6',
    categoryId: 'cat-tutorials',
    title: '商业计划书设计指南：用 luluca 打造专业 PPT',
    excerpt: '从封面到数据图表，手把手教你用 luluca 制作一份投资人眼前一亮的商业计划书。',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20presentation%20slides%20on%20laptop%20screen%2C%20business%20meeting%20setup%2C%20warm%20office%20lighting%2C%20modern%20minimal%20workspace%2C%20clean%20desk%2C%20professional%20atmosphere&width=800&height=450&seq=article-cover-6&orientation=landscape',
    author: 'luluca 官方',
    date: '2026-07-22',
    readTime: '15 分钟',
    tags: ['商业', 'PPT', '演示文稿'],
  },
  {
    id: 'article-7',
    categoryId: 'cat-cases',
    title: '用户故事：独立设计师如何用 luluca 提升3倍效率',
    excerpt: '一位自由设计师分享他使用 luluca 前后的工作流变化，以及如何将接单量翻了三倍。',
    coverImage: 'https://readdy.ai/api/search-image?query=Freelance%20designer%20working%20happily%20in%20home%20studio%2C%20multiple%20screens%20showing%20creative%20work%2C%20warm%20natural%20light%2C%20plants%20on%20desk%2C%20cozy%20creative%20atmosphere%2C%20modern%20interior&width=800&height=450&seq=article-cover-7&orientation=landscape',
    author: '张明远',
    date: '2026-07-20',
    readTime: '8 分钟',
    tags: ['案例', '设计师', '效率'],
  },
  {
    id: 'article-8',
    categoryId: 'cat-cases',
    title: '从0到10万粉丝：一个美妆博主的 luluca 创作之路',
    excerpt: '美妆博主分享如何利用 luluca 打造统一的视觉风格，在半年内实现粉丝快速增长。',
    coverImage: 'https://readdy.ai/api/search-image?query=Beauty%20content%20creator%20filming%20in%20bright%20studio%2C%20ring%20light%2C%20makeup%20products%20organized%2C%20warm%20lighting%2C%20modern%20minimal%20aesthetic%2C%20creative%20workspace%2C%20clean%20setup&width=800&height=450&seq=article-cover-8&orientation=landscape',
    author: '美妆达人 Lily',
    date: '2026-07-18',
    readTime: '10 分钟',
    tags: ['案例', '社交媒体', '博主'],
  },
  {
    id: 'article-9',
    categoryId: 'cat-updates',
    title: 'luluca 2026年8月版本更新：全新 AI 引擎上线',
    excerpt: '本次更新带来革命性的 AI 创作引擎升级，生成速度提升200%，新增10种艺术风格支持。',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20technology%20interface%20with%20glowing%20elements%2C%20AI%20concept%20visualization%2C%20warm%20amber%20accents%2C%20minimalist%20design%2C%20soft%20gradient%20background%2C%20modern%20tech%20aesthetic&width=800&height=450&seq=article-cover-9&orientation=landscape',
    author: 'luluca 官方',
    date: '2026-08-01',
    readTime: '6 分钟',
    tags: ['更新', '版本', 'AI'],
  },
  {
    id: 'article-10',
    categoryId: 'cat-tips',
    title: '10个提升设计效率的 luluca 隐藏技巧',
    excerpt: '这些你可能不知道的快捷操作和隐藏功能，能让你的创作效率翻倍。',
    coverImage: 'https://readdy.ai/api/search-image?query=Creative%20workspace%20with%20keyboard%20shortcuts%20concept%2C%20warm%20lighting%2C%20minimalist%20desk%2C%20design%20tools%2C%20modern%20setup%2C%20productive%20atmosphere%2C%20clean%20composition&width=800&height=450&seq=article-cover-10&orientation=landscape',
    author: '效率专家阿杰',
    date: '2026-07-15',
    readTime: '7 分钟',
    tags: ['技巧', '快捷键', '效率'],
  },
  {
    id: 'article-11',
    categoryId: 'cat-tips',
    title: '设计师必备：luluca 色彩搭配黄金法则',
    excerpt: '掌握这些色彩搭配的基本原则，结合 luluca 的 AI 配色工具，让你的设计更上一层楼。',
    coverImage: 'https://readdy.ai/api/search-image?query=Color%20theory%20wheel%20with%20design%20samples%2C%20artistic%20studio%20setup%2C%20warm%20lighting%2C%20paint%20swatches%2C%20modern%20minimal%20workspace%2C%20creative%20atmosphere%2C%20soft%20shadows&width=800&height=450&seq=article-cover-11&orientation=landscape',
    author: '色彩大师小林',
    date: '2026-07-12',
    readTime: '9 分钟',
    tags: ['色彩', '搭配', '技巧'],
  },
  {
    id: 'article-12',
    categoryId: 'cat-getting-started',
    title: '账号注册与团队创建：luluca 账户体系全解析',
    excerpt: '了解个人账户与团队账户的区别，学习如何创建和管理团队，合理分配角色权限。',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20signup%20interface%20on%20laptop%20screen%2C%20clean%20minimal%20design%2C%20warm%20ambient%20light%2C%20cozy%20workspace%2C%20professional%20setup%2C%20soft%20shadows%2C%20modern%20aesthetic&width=800&height=450&seq=article-cover-12&orientation=landscape',
    author: 'luluca 官方',
    date: '2026-07-10',
    readTime: '6 分钟',
    tags: ['账号', '团队', '入门'],
  },
];

export interface ArticleDetail extends ArticlePreview {
  contentHtml: string;
}

export const articleDetailsData: Record<string, ArticleDetail> = {
  'article-1': {
    id: 'article-1',
    categoryId: 'cat-getting-started',
    title: '5分钟快速上手 luluca：新用户必看入门指南',
    excerpt: '刚接触 luluca？这篇指南将带你从注册账号到完成第一个作品，只需5分钟就能掌握核心操作流程。',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20workspace%20with%20laptop%20displaying%20creative%20design%20software%20interface%2C%20warm%20ambient%20lighting%2C%20clean%20desk%20setup%2C%20coffee%20cup%2C%20artistic%20atmosphere%2C%20soft%20shadows&width=800&height=450&seq=article-cover-1&orientation=landscape',
    author: 'luluca 官方',
    date: '2026-08-05',
    readTime: '5 分钟',
    tags: ['入门', '新手指南', '快速上手'],
    contentHtml: '<p>欢迎来到 luluca！这篇快速入门指南将帮助你在5分钟内掌握 luluca 的核心操作流程。无论你是设计新手还是经验丰富的创作者，luluca 都能让你快速进入创作状态。</p><h2>第一步：注册账号</h2><p>访问 luluca 官网，点击右上角的"免费注册"按钮。你可以使用邮箱注册，也支持微信、Google 等第三方账号快速登录。注册完成后，系统会引导你完成简单的偏好设置，包括感兴趣的创作领域和使用场景。</p><h2>第二步：熟悉工作台</h2><p>登录后你会看到 luluca 的主工作台。左侧是模板库和素材面板，中央是画布编辑区，右侧是属性设置面板。顶部工具栏提供了常用操作的快捷入口。花一分钟浏览这些区域，你会很快上手。</p><h2>第三步：选择模板</h2><p>点击左侧模板库，你可以按类别浏览或搜索关键词。选择一个你喜欢的模板，点击即可加载到画布中。luluca 提供了超过10,000款模板，从社交媒体封面到商业演示，应有尽有。</p><h2>第四步：个性化编辑</h2><p>模板加载后，你可以自由修改文字内容、替换图片、调整颜色和字体。点击任意元素即可在右侧面板中看到对应属性。luluca 的 AI 配色助手还会在你调整颜色时给出专业建议。</p><h2>第五步：导出与分享</h2><p>完成设计后，点击右上角的"导出"按钮。luluca 支持 PNG、JPG、PDF、SVG 等多种格式，还可以直接分享到社交媒体平台或生成分享链接发给团队成员。</p><p>恭喜你！你已经完成了第一个 luluca 作品。这只是开始，luluca 还有更多强大的功能等你探索。继续阅读其他教程，成为 luluca 创作达人吧！</p>',
  },
  'article-2': {
    id: 'article-2',
    categoryId: 'cat-getting-started',
    title: 'luluca 界面布局详解：认识每一个功能区域',
    excerpt: '全面了解 luluca 的工作台布局，从工具栏到图层面板，熟悉每个功能区域的作用与快捷操作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Clean%20modern%20UI%20interface%20design%20mockup%20on%20screen%2C%20creative%20software%20workspace%2C%20warm%20neutral%20tones%2C%20minimalist%20desk%20environment%2C%20soft%20natural%20light%2C%20professional%20setup&width=800&height=450&seq=article-cover-2&orientation=landscape',
    author: '陈小北',
    date: '2026-08-03',
    readTime: '8 分钟',
    tags: ['界面', '工作台', '基础操作'],
    contentHtml: '<p>luluca 的工作台经过精心设计，将复杂功能隐藏在简洁界面背后。本文将带你全面了解每个功能区域，让你在使用时得心应手。</p><h2>顶部导航栏</h2><p>顶部导航栏包含项目名称、文件操作（新建、打开、保存）、撤销/重做按钮以及分享和导出入口。右侧是账户信息和设置菜单。</p><h2>左侧面板：素材与模板</h2><p>左侧面板是你的创意弹药库。这里分为模板库、素材库、我的上传和品牌素材四个标签页。你可以在这里浏览模板、搜索素材图片、管理上传的文件以及设置品牌专属素材。</p><h2>中央画布区</h2><p>画布区是你创作的主战场。支持缩放、平移操作，底部有缩放滑块和适配按钮。你可以在画布上直接拖拽、旋转、缩放元素，所见即所得。</p><h2>右侧属性面板</h2><p>选中画布中的任意元素后，右侧面板会显示该元素的所有属性，包括位置尺寸、颜色填充、文字样式、阴影效果、透明度等。这是精细调整设计的关键区域。</p><h2>底部图层面板</h2><p>图层面板展示当前设计的所有图层，支持拖拽排序、显示/隐藏、锁定和解锁。合理的图层管理是高效设计的基础。</p><h2>快捷键一览</h2><p>Ctrl+Z 撤销、Ctrl+S 保存、Ctrl+D 复制、Delete 删除选中元素、Space+拖拽 平移画布、Ctrl+滚轮 缩放画布。掌握这些快捷键能大幅提升操作效率。</p>',
  },
  'article-3': {
    id: 'article-3',
    categoryId: 'cat-features',
    title: 'AI 智能配色：让你的设计配色不再纠结',
    excerpt: 'luluca 的 AI 配色引擎如何工作？深入了解智能配色背后的原理，以及如何利用它快速打造专业配色方案。',
    coverImage: 'https://readdy.ai/api/search-image?query=Color%20palette%20swatches%20arranged%20artistically%20on%20warm%20minimal%20background%2C%20design%20tools%2C%20creative%20studio%20vibe%2C%20soft%20lighting%2C%20harmonious%20color%20combinations%2C%20modern%20aesthetic&width=800&height=450&seq=article-cover-3&orientation=landscape',
    author: '王设计',
    date: '2026-08-01',
    readTime: '10 分钟',
    tags: ['AI', '配色', '设计技巧'],
    contentHtml: '<p>配色是设计中最让人头疼的环节之一。luluca 的 AI 智能配色引擎基于深度学习和色彩理论，能够自动生成专业级别的配色方案。本文将深入解析这一功能。</p><h2>AI 配色的工作原理</h2><p>luluca 的 AI 配色引擎分析了超过100万份优秀设计作品的配色数据，结合色彩心理学和设计理论，训练出了能够理解"美感"的深度学习模型。当你选择一张图片或一个主色调后，AI 会自动生成与之搭配的辅助色和点缀色。</p><h2>如何使用 AI 配色</h2><p>在编辑任意元素时，点击颜色选择器中的"AI 推荐"标签，系统会基于当前设计的整体风格，为你推荐5-10组配色方案。你也可以上传参考图片，AI 会从中提取配色灵感。</p><h2>配色方案的调整与保存</h2><p>每一组 AI 推荐的配色方案都可以手动微调。调整后你可以将配色方案保存到"我的配色库"，方便在其他设计中复用，保持品牌视觉一致性。</p><h2>实战案例</h2><p>以制作一份科技感的海报为例，AI 推荐了以深空灰为主色、电光蓝为辅助色、亮橙色为点缀的配色方案。这种配色既体现了科技感，又通过橙色点缀增加了视觉吸引力。</p>',
  },
  'article-4': {
    id: 'article-4',
    categoryId: 'cat-features',
    title: '模板库深度解析：找到最适合你的设计起点',
    excerpt: 'luluca 模板库涵盖哪些类别？如何根据需求快速筛选和定制模板？一文带你玩转模板功能。',
    coverImage: 'https://readdy.ai/api/search-image?query=Collection%20of%20design%20templates%20displayed%20on%20screen%20grid%2C%20minimalist%20workspace%2C%20warm%20ambient%20light%2C%20clean%20modern%20aesthetic%2C%20creative%20studio%20atmosphere%2C%20organized%20layout&width=800&height=450&seq=article-cover-4&orientation=landscape',
    author: 'luluca 官方',
    date: '2026-07-28',
    readTime: '12 分钟',
    tags: ['模板', '设计', '效率'],
    contentHtml: '<p>luluca 模板库是平台的核心资产之一，拥有超过10,000款精心设计的模板。本文将带你深入了解模板库的分类体系和使用技巧。</p><h2>模板分类概览</h2><p>模板库按使用场景分为十大类别：社交媒体（小红书封面、朋友圈海报、抖音封面等）、商业演示（PPT、商业计划书、路演材料等）、品牌设计（Logo、名片、品牌手册等）、印刷物料（海报、传单、折页等）、电商素材（主图、详情页、Banner等）、教育培训（课件、图表、证书等）、活动邀请（请柬、活动海报等）、简历作品集、视频封面以及插画素材。</p><h2>智能搜索与筛选</h2><p>除了按类别浏览，你还可以使用搜索功能直接输入关键词查找模板。筛选器支持按颜色风格、尺寸比例、热度排序等维度进行精准筛选。AI 还会根据你的使用历史，在首页推荐你可能感兴趣的模板。</p><h2>模板定制技巧</h2><p>每个模板都是完全可定制的。你可以修改文字内容、替换图片、调整颜色主题、增减页面元素。luluca 的"智能适配"功能还能在你更换模板尺寸时自动调整布局。</p><h2>创建你的品牌模板</h2><p>对于企业用户，你可以将常用的设计保存为品牌模板，设置好品牌色、Logo、字体等固定元素，团队成员使用时只需修改可变内容即可，确保品牌视觉一致性。</p>',
  },
};